import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
  } from "chart.js";
  import "chartjs-adapter-date-fns";
  import "../Dashboard/Dashboard.scss";
import TrackShipmentByAccount from '../Dashboard/TrackShipmentByAccount';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);
const TrackDetails = () => {
  return (
    <div>
        <TrackShipmentByAccount />
    </div>
  )
}

export default TrackDetails